module.exports = __webpack_public_path__ + "img/cleaned_mirro.19b73d87.svg";